<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],    
 data() {
  return {
   title: "User Management",
   text: "User Management",
   text1: "Module",
   toast: useToast(),
   data: [],
  };
},

 mounted() {
  this.modules();
 }, 
 methods: {
  toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
 },

 async modules(){
  this.setLoading(true);
  try{
   const response = await axios.get('/modules');
   this.data = response.data.data;
  }catch(error){
   this.toast.error(error.message);
  }finally{
   this.setLoading(false);
  }
 }

},
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div
class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
>
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<div class="mb-2">
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#module_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.moduleModal.add();"><i class="ti ti-circle-plus me-2"></i>Add Module</a>
</div>
<div class="head-icons ms-2">
<a
    href="javascript:void(0);"
    class=""
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    data-bs-original-title="Collapse"
    id="collapse-header"
    @click="toggleHeader"
>
    <i class="ti ti-chevrons-up"></i>
</a>
</div>
</div>
</div>
<!-- /Breadcrumb -->

<div class="card">
<div
class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
>
<h5>Modules List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
<!-- <div class="dropdown">
 <a href="javascript:void(0);"
    class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
    data-bs-toggle="dropdown"
    >
    Sort By : Last 7 Days
    </a>
    <ul class="dropdown-menu dropdown-menu-end p-3">
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Recently Added</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Ascending</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Desending</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Last Month</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Last 7 Days</a
        >
    </li>
    </ul>
</div> -->
</div>
</div>
<div class="card-body p-0">
<div class="custom-datatable-filter table-responsive">

<table class="table table-striped mb-0" v-if="data.length">
<thead>
<tr>
<th>#</th>
<th>Module Name</th>
<th>Actions</th>
</tr>
</thead>
<tbody>
 <tr v-for="(row, index) in data" :key="row.id">
  <td>{{ index + 1 }}</td>  
  <td>{{ row.name }}</td>
  <td>
    <div class="action-icon d-inline-flex">
    <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#module_modal" class="me-2" @click="$refs.moduleModal.editModule(row)"><i class="ti ti-edit"></i></a>
    <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.moduleModal.editModule(row)"><i class="ti ti-trash"></i></a>
   </div>
  </td>
</tr>
</tbody>
</table>

<div v-else class="p-3 text-center text-muted">
  No records found.
</div>

</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<module-modal ref="moduleModal" @updated="modules"></module-modal>
</template>
